import { Api } from '../api/api';
import { Injectable } from '@angular/core';
import { Logger } from 'ionic-logging-service';
import {EventData} from '../../interfaces/event-data';
import {LocalDataSource} from '../../ng2-smart-table/lib/data-source/local/local.data-source';

/*
  Generated class for the AlertEventsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AlertEventsProvider {

  eventsData: Array<EventData> = [];
  tableData: LocalDataSource = new LocalDataSource();

  private logger: Logger;

  constructor(public api: Api) {
  }

  private getLogger() {
    if(this.logger) {
      return this.logger;
    }

    return this.logger = this.api.getLogger('Hausnotruf.AlertEventsDataProvider');
  }

  get() {
    this.getLogger().info('get', {message: 'AlertEvent lesen'});
    this.api.get('events').subscribe((eventsData: any) => {
      this.eventsData = eventsData.data.data.data.docs;
      this.tableData.load(this.eventsData);
    });
  }

  add(item: EventData) {
    this.getLogger().info('add', {message: 'AlertEvent angelegt'});
    this.tableData.prepend(item);
  }

  delete(item: EventData) {
    this.getLogger().info('remove', {message: 'EventsData gelöscht'});
    this.eventsData.splice(this.eventsData.indexOf(item), 1);
  }

}
